module.exports = __webpack_public_path__ + "static/media/VirgoSillamaa.c4eff191.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/VirgoSillamaa.jpg
// module id = 609
// module chunks = 0